"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookie = exports.getGeoProperties = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
var constants_1 = require("../constants");
var getGeoProperties = function () { return ({
    geo_country: (0, exports.getCookie)(constants_1.ipCountryCookie),
}); };
exports.getGeoProperties = getGeoProperties;
var getCookie = function (cookieName) {
    return js_cookie_1.default.get(cookieName);
};
exports.getCookie = getCookie;
//# sourceMappingURL=cookieUtils.js.map